import { useEffect } from 'react';

import { useAppSelector } from 'hooks/useAppSelector';
import { useTypedDispatch } from 'hooks/useTypedDispatch';
import { selectNotification } from 'state';
import { setNotification } from 'state/actions';

export const useHandleNotification = (): string | null => {
  const dispatch = useTypedDispatch();
  const notification = useAppSelector(selectNotification);

  useEffect(() => {
    if (notification) {
      const timerId = setTimeout(() => {
        dispatch(setNotification(''));
        clearTimeout(timerId);
      }, 3000);
    }
  }, [dispatch, notification]);

  return notification;
};
